import { useMutation } from '@gogame/query';

import { exportFromGoogleDrive } from 'scenes/MarketingPlanning/MarketingPlanningGrid/sources/marketingPlanning';

import { exportGoogleDrive } from '../queryKeyFactory';

export const useExportFromGoogleDrive = () => {
  const exportMutation = useMutation(
    exportGoogleDrive(),
    exportFromGoogleDrive,
    {
      onSuccess: ({ fileId }) => {
        window.open(
          `https://docs.google.com/spreadsheets/d/${fileId}`,
          '_blank'
        );
      },
      successMessage: () => 'Export to Google Drive completed',
      refresh: false,
    }
  );

  return [exportMutation.mutateAsync, exportMutation];
};
